import axios from 'axios';
import router from '@/router';
import store from '@/store';


// console.log(import.meta.env);


const baseURL =
    window.location.hostname === "localhost"
        ? "http://127.0.0.1:8001/api" // Dev API
        : "https://services.relaincehealth.com/api"; // Production API
// const apiEnv = import.meta.env.VITE_APP_ENV || "default_value";
// console.log("API Environment:", apiEnv);
// const baseURL = import.meta.env.VITE_APP_ENV == 'production' ? import.meta.env.VITE_APP_API_URL_PROD : import.meta.env.VITE_API_BASE_URL;
// console.log(baseURL);
// Create an Axios instance with default settings
const api = axios.create({
    baseURL, // Change to your Laravel API base URL
    headers: {
        'Content-Type': 'application/json'
    }
});

// Automatically include Authorization header if token exists
api.interceptors.request.use(
    (config) => {
        // Start the loading indicator
        if (window.appLoader && !config.skipLoader) {
            window.appLoader.start();
        }
        
        // Add auth token
        const token = localStorage.getItem('lunar-token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        // Hide loader on request error
        if (window.appLoader) {
            window.appLoader.finish();
        }
        return Promise.reject(error);
    }
);

// Response interceptor to handle responses and errors
api.interceptors.response.use(
    (response) => {
        // Hide loader on successful response
        if (window.appLoader) {
            window.appLoader.finish();
        }
        return response;
    },
    (error) => {
        // Hide loader on response error
        if (window.appLoader) {
            window.appLoader.finish();
        }
        
        // Handle authentication errors
        if (error.response && error.response.status === 401) {
            // Redirect to login or handle token expiration
            // You might want to dispatch a logout action here
        }
        
        return Promise.reject(error);
    }
);


api.interceptors.response.use(
    response => response,
    error => {

        if (error.response && error.response.status === 401) {
            store.commit('LOGOUT'); // Vuex commit logout
            router.push('/login'); // Redirect to login page
        }
        return Promise.reject(error);
    }
);


export default api;

